import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _02a58d96 = () => interopDefault(import('../pages/vacancies/index.vue' /* webpackChunkName: "pages/vacancies/index" */))
const _0c26302f = () => interopDefault(import('../pages/cargo-landing/_.vue' /* webpackChunkName: "" */))
const _4fefe092 = () => interopDefault(import('../pages/transport/_.vue' /* webpackChunkName: "pages/transport/_" */))
const _0da59205 = () => interopDefault(import('../pages/transport/index.vue' /* webpackChunkName: "pages/transport/index" */))
const _2a4a017b = () => interopDefault(import('../pages/tip-gruza/_/products.vue' /* webpackChunkName: "pages/tip-gruza/_/products" */))
const _f72cc96a = () => interopDefault(import('../pages/tip-gruza/_/index.vue' /* webpackChunkName: "pages/tip-gruza/_/index" */))
const _24f01d8a = () => interopDefault(import('../pages/tip-gruza/index.vue' /* webpackChunkName: "pages/tip-gruza/index" */))
const _50c95818 = () => interopDefault(import('../pages/sets/_.vue' /* webpackChunkName: "pages/sets/_" */))
const _1df04f62 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _f492cf42 = () => interopDefault(import('../pages/routes/_cityfrom/_cityto/index.vue' /* webpackChunkName: "pages/routes/_cityfrom/_cityto/index" */))
const _f94e42ae = () => interopDefault(import('../pages/routes/_cityfrom/index.vue' /* webpackChunkName: "pages/routes/_cityfrom/index" */))
const _92fd42f8 = () => interopDefault(import('../pages/routes/index.vue' /* webpackChunkName: "pages/routes/index" */))
const _1efed97a = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _14535f9e = () => interopDefault(import('../pages/otrasli/_/products.vue' /* webpackChunkName: "pages/otrasli/_/products" */))
const _208aa808 = () => interopDefault(import('../pages/otrasli/_/index.vue' /* webpackChunkName: "pages/otrasli/_/index" */))
const _61e1ed90 = () => interopDefault(import('../pages/otrasli/index.vue' /* webpackChunkName: "pages/otrasli/index" */))
const _3a553545 = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _3c0bd68d = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _40c7040e = () => interopDefault(import('../pages/lk/index.vue' /* webpackChunkName: "pages/lk/index" */))
const _211c6a17 = () => interopDefault(import('../pages/gruzopodemnost/_.vue' /* webpackChunkName: "pages/gruzopodemnost/_" */))
const _0a905dec = () => interopDefault(import('../pages/gruzopodemnost/index.vue' /* webpackChunkName: "pages/gruzopodemnost/index" */))
const _73dc504b = () => interopDefault(import('../pages/events/_slug.vue' /* webpackChunkName: "pages/events/_slug" */))
const _7592f193 = () => interopDefault(import('../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _25d04d47 = () => interopDefault(import('../pages/distillation/_id/_vin.vue' /* webpackChunkName: "pages/distillation/_id/_vin" */))
const _0bf39b77 = () => interopDefault(import('../pages/distillation/_id/index.vue' /* webpackChunkName: "pages/distillation/_id/index" */))
const _83aeb2e8 = () => interopDefault(import('../pages/distillation/index.vue' /* webpackChunkName: "pages/distillation/index" */))
const _6d81edcc = () => interopDefault(import('../pages/cargo-rate-calculator/index.vue' /* webpackChunkName: "pages/cargo-rate-calculator/index" */))
const _115a78af = () => interopDefault(import('../pages/articles/_slug.vue' /* webpackChunkName: "pages/articles/_slug" */))
const _131119f7 = () => interopDefault(import('../pages/articles/index.vue' /* webpackChunkName: "pages/articles/index" */))
const _f8ebb790 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/vacancies",
    component: _02a58d96,
    name: "vacancies"
  }, {
    path: "/ural/:slug",
    components: {
      default: _0c26302f
    }
  }, {
    path: "/transport/*",
    component: _4fefe092,
    name: "transport-all"
  }, {
    path: "/transport",
    component: _0da59205,
    name: "transport"
  }, {
    path: "/tip-gruza/*/products",
    component: _2a4a017b,
    name: "tip-gruza-all-products"
  }, {
    path: "/tip-gruza/*",
    component: _f72cc96a,
    name: "tip-gruza-all"
  }, {
    path: "/tip-gruza",
    component: _24f01d8a,
    name: "tip-gruza"
  }, {
    path: "/sets/*",
    component: _50c95818,
    name: "sets-all"
  }, {
    path: "/search",
    component: _1df04f62,
    name: "search"
  }, {
    path: "/routes/:cityfrom/:cityto",
    component: _f492cf42,
    name: "routes-cityfrom-cityto"
  }, {
    path: "/routes/:cityfrom",
    component: _f94e42ae,
    name: "routes-cityfrom"
  }, {
    path: "/routes",
    component: _92fd42f8,
    name: "routes"
  }, {
    path: "/product/:slug?",
    component: _1efed97a,
    name: "product-slug"
  }, {
    path: "/otrasli/*/products",
    component: _14535f9e,
    name: "otrasli-all-products"
  }, {
    path: "/otrasli/*",
    component: _208aa808,
    name: "otrasli-all"
  }, {
    path: "/otrasli",
    component: _61e1ed90,
    name: "otrasli"
  }, {
    path: "/news/:slug",
    component: _3a553545,
    name: "news-slug"
  }, {
    path: "/news",
    component: _3c0bd68d,
    name: "news"
  }, {
    path: "/lk",
    component: _40c7040e,
    name: "lk"
  }, {
    path: "/gruzopodemnost/*",
    component: _211c6a17,
    name: "gruzopodemnost-all"
  }, {
    path: "/gruzopodemnost",
    component: _0a905dec,
    name: "gruzopodemnost"
  }, {
    path: "/events/:slug",
    component: _73dc504b,
    name: "events-slug"
  }, {
    path: "/events",
    component: _7592f193,
    name: "events"
  }, {
    path: "/distillation/:id/:vin",
    component: _25d04d47,
    name: "distillation-id-vin"
  }, {
    path: "/distillation/:id",
    component: _0bf39b77,
    name: "distillation-id"
  }, {
    path: "/distillation",
    component: _83aeb2e8,
    name: "distillation"
  }, {
    path: "/cargo-rate-calculator",
    component: _6d81edcc,
    name: "cargo-rate-calculator"
  }, {
    path: "/cargo-landing/*",
    component: _0c26302f,
    name: "cargo-landing-all"
  }, {
    path: "/articles/:slug",
    component: _115a78af,
    name: "articles-slug"
  }, {
    path: "/articles",
    component: _131119f7,
    name: "articles"
  }, {
    path: "/*",
    component: _f8ebb790,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
